<template>
  <v-dialog v-model="dialog" width="1200" scrollable>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        {{ specie.nome }}
      </v-card-title>
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab>
          <v-icon left small>mdi-palette</v-icon>
          Colori
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-sprout</v-icon>
          Serie e Varietà
        </v-tab>
      </v-tabs>
      <v-divider />
      <v-card-text class="pa-0" style="height: calc(85vh - 108px)">
        <v-row no-gutters style="height: 100%">

          <!-- SIDEBAR SERIE (fissa) -->
          <v-col cols="3" style="height: 100%; overflow-y: auto; border-right: 1px solid rgba(0,0,0,0.12)">
            <v-row no-gutters align="center" class="px-3 pt-2 pb-4">
              <span class="text-caption grey--text text-uppercase font-weight-medium">Serie</span>
              <v-spacer />
              <v-dialog width="400" v-model="dialog_serie">
                <template v-slot:activator="{ on }">
                  <v-btn outlined color="green" v-on="on">
                    <v-icon left small>mdi-plus</v-icon> Nuova
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="grey--text text-subtitle-1">Nuova Serie</v-card-title>
                  <v-card-text>
                    <v-text-field
                      outlined
                      label="Nome"
                      hide-details
                      v-model="nome_serie"
                      @keypress.enter="salva_serie()"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn outlined color="green" @click="salva_serie()" :loading="loading_serie">
                      Salva
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-divider />
            <v-list dense>
              <v-list-item @click="set_serie_attiva(null)" :class="{ 'green lighten-5': !serie_attiva }">
                <v-list-item-avatar color="grey lighten-3" size="36">
                  <v-icon small color="green">mdi-sprout</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title :class="{ 'green--text font-weight-medium': !serie_attiva }">
                    Tutte
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <SerieElement
                v-for="serie in serie_sort"
                :serie="serie"
                :id_specie="specie.id"
                :attiva="serie_attiva && serie_attiva.id === serie.id"
                :key="serie.id"
                @set_serie_attiva="set_serie_attiva"
              />
            </v-list>
          </v-col>

          <!-- COLONNA DESTRA — contenuto cambia col tab -->
          <v-col cols="9" style="height: 100%; overflow: hidden">
            <v-tabs-items v-model="tab" style="height: 100%">

              <!-- TAB COLORI -->
              <v-tab-item style="height: 100%">
                <v-row no-gutters align="center" class="px-3 pt-2 pb-4" style="gap:8px">
                  <span class="text-caption grey--text text-uppercase font-weight-medium">Colori</span>
                  <v-spacer />
                  <NuovoColore :id_specie="specie.id" :serie="serie_attiva">
                    <template v-slot:activator="{ on }">
                      <v-btn outlined color="green" v-on="on">
                        <v-icon left small>mdi-plus</v-icon> Nuovo
                      </v-btn>
                    </template>
                  </NuovoColore>
                </v-row>
                <v-divider />
                <div style="overflow-y: auto; overflow-x: hidden; max-height: calc(85vh - 220px)">
                  <template v-if="!serie_attiva">
                    <div v-for="gruppo in colori_per_serie" :key="gruppo.id_serie || 'nessuna'" class="mb-3">
                      <v-row no-gutters align="center" class="mt-3 px-2" style="gap:8px">
                        <span class="text-caption grey--text text-uppercase font-weight-medium" style="white-space:nowrap">{{ gruppo.nome_serie }}</span>
                        <span class="text-caption grey--text">({{ gruppo.colori.length }})</span>
                        <v-divider />
                      </v-row>
                      <v-row no-gutters class="mt-1">
                        <v-col cols="4" v-for="colore in gruppo.colori" :key="colore.id">
                          <ColoreElement
                            :colore="colore"
                            :id_specie="specie.id"
                            :series="serie_sort"
                            @specie_changed="fetchAllColors"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <v-row v-if="colori.length === 0" class="mt-4 pb-4 justify-center">
                      <span class="grey--text">Nessun colore</span>
                    </v-row>
                  </template>
                  <template v-else>
                    <v-row no-gutters class="mt-1">
                      <v-col cols="4" v-for="colore in colori_filter" :key="colore.id">
                        <ColoreElement
                          :colore="colore"
                          :id_specie="specie.id"
                          :series="serie_sort"
                          @specie_changed="fetchAllColors"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="colori_filter.length === 0" class="mt-4 pb-4 justify-center">
                      <span class="grey--text">Nessun colore per questa serie</span>
                    </v-row>
                  </template>
                </div>
              </v-tab-item>

              <!-- TAB VARIETÀ -->
              <v-tab-item>
                <v-row no-gutters align="center" class="px-3 pt-2 pb-3" style="gap:8px">
                  <span class="text-caption grey--text text-uppercase font-weight-medium">Varietà</span>
                  <v-spacer />
                  <v-autocomplete
                    v-model="fornitore_filtro"
                    :items="fornitori_usati"
                    item-text="nome"
                    item-value="id"
                    dense
                    hide-details
                    clearable
                    outlined
                    style="max-width:190px"
                    placeholder="Filtra fornitore"
                    prepend-inner-icon="mdi-filter-outline"
                  />
                  <NuovoVarieta :specie="specie" :colori="colori">
                    <template v-slot:activator="{ on }">
                      <v-btn outlined color="green" v-on="on">
                        <v-icon left small>mdi-plus</v-icon> Nuova
                      </v-btn>
                    </template>
                  </NuovoVarieta>
                </v-row>
                <v-divider />
                <div style="overflow-y: auto; overflow-x: hidden; max-height: calc(85vh - 180px)">
                  <template v-if="!serie_attiva">
                    <div v-for="gruppo in varieta_raggruppate_per_serie" :key="gruppo.id_serie || 'nessuna'" class="mb-2">
                      <v-row no-gutters align="center" class="mt-3 px-2" style="gap:8px">
                        <span class="text-caption grey--text text-uppercase font-weight-medium" style="white-space:nowrap">{{ gruppo.nome_serie }}</span>
                        <span class="text-caption grey--text">({{ gruppo.varieta.length }})</span>
                        <v-divider />
                      </v-row>
                      <VarietaGruppoElement
                        v-for="v in gruppo.varieta"
                        :key="v.serie + '_' + v.nome + '_' + v.id_colore"
                        :varieta="v"
                        :id_specie="specie.id"
                        :series="specie.series"
                        :colori="colori"
                      />
                    </div>
                    <v-row v-if="varieta_filtrate.length === 0" class="my-4 justify-center">
                      <span class="grey--text">Nessuna varietà</span>
                    </v-row>
                  </template>
                  <template v-else>
                    <VarietaGruppoElement
                      v-for="v in varieta_filtrate"
                      :key="v.serie + '_' + v.nome + '_' + v.id_colore"
                      :varieta="v"
                      :id_specie="specie.id"
                      :series="specie.series"
                      :colori="colori"
                    />
                    <v-row v-if="varieta_filtrate.length === 0" class="my-4 justify-center">
                      <span class="grey--text">Nessuna varietà per questa serie</span>
                    </v-row>
                  </template>
                </div>
              </v-tab-item>

            </v-tabs-items>
          </v-col>

        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="close()">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NuovoVarieta from "./nuovo_varieta.vue";
import NuovoColore from "../colori/nuovo_colore.vue";
import ColoreElement from "../colori/colore_element.vue";
import SerieElement from "./serie_element.vue";
import VarietaGruppoElement from "./varieta_gruppo_element.vue";

export default {
  components: {
    NuovoVarieta,
    NuovoColore,
    ColoreElement,
    SerieElement,
    VarietaGruppoElement,
  },
  props: {
    specie: Object,
  },
  data() {
    return {
      dialog: false,
      tab: 0,
      nome_serie: "",
      loading_serie: false,
      dialog_serie: false,
      colori: [],
      serie_attiva: null,
      fornitore_filtro: null,
    };
  },
  watch: {
    "specie.colori": {
      immediate: true,
      handler(newVal) {
        if (newVal) this.fetchAllColors();
      },
    },
  },
  computed: {
    serie_sort() {
      return this.specie.series.slice().sort((a, b) => a.nome.localeCompare(b.nome));
    },
    colori_filter() {
      if (!this.serie_attiva) return this.colori;
      return this.colori.filter((c) => c.id_series.includes(this.serie_attiva.id));
    },
    varieta_raggruppate_per_serie() {
      const map = {};
      this.varieta_filtrate.forEach((v) => {
        const key = v.serie || 'nessuna';
        if (!map[key]) map[key] = [];
        map[key].push(v);
      });
      const result = [];
      this.serie_sort.forEach((serie) => {
        if (map[serie.id]) {
          result.push({ id_serie: serie.id, nome_serie: serie.nome, varieta: map[serie.id] });
        }
      });
      if (map['nessuna']) {
        result.push({ id_serie: null, nome_serie: 'Senza serie', varieta: map['nessuna'] });
      }
      return result;
    },
    colori_per_serie() {
      const result = [];
      this.serie_sort.forEach((serie) => {
        const colori = this.colori.filter((c) => c.id_series.includes(serie.id));
        if (colori.length > 0) {
          result.push({ id_serie: serie.id, nome_serie: serie.nome, colori });
        }
      });
      const senza_serie = this.colori.filter((c) => !c.id_series || c.id_series.length === 0);
      if (senza_serie.length > 0) {
        result.push({ id_serie: null, nome_serie: 'Senza serie', colori: senza_serie });
      }
      return result;
    },
    fornitori_usati() {
      const ids = new Set();
      this.varieta_per_serie.forEach((g) =>
        g.fornitori.forEach((f) => ids.add(f.id_produttore))
      );
      return this.$store.getters.get_fornitori.filter((f) => ids.has(f.id));
    },
    varieta_filtrate() {
      if (!this.fornitore_filtro) return this.varieta_per_serie;
      return this.varieta_per_serie.filter((g) =>
        g.fornitori.some((f) => f.id_produttore == this.fornitore_filtro)
      );
    },
    varieta_per_serie() {
      const filtrate = this.serie_attiva
        ? this.specie.variety.filter((v) => v.serie == this.serie_attiva.id)
        : this.specie.variety;

      const map = {};
      filtrate.forEach((v) => {
        const key = `${v.serie}_${v.nome}_${v.id_colore}`;
        if (!map[key]) {
          map[key] = {
            nome: v.nome,
            id_colore: v.id_colore,
            md5_colore: v.md5_colore,
            serie: v.serie,
            fornitori: [],
          };
        }
        map[key].fornitori.push({ id: v.id, id_produttore: v.id_produttore });
      });

      return Object.values(map).sort((a, b) => a.nome.localeCompare(b.nome));
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async fetchAllColors() {
      this.colori = await this.$store.dispatch("fetch_colori_by_id", this.specie.colori);
    },
    set_serie_attiva(id_serie) {
      this.serie_attiva = id_serie
        ? this.specie.series.find((s) => s.id == id_serie)
        : null;
      this.fornitore_filtro = null;
    },
    salva_serie() {
      this.loading_serie = true;
      this.$store
        .dispatch("nuova_serie_specie", {
          id_specie: this.specie.id,
          nome: this.nome_serie,
        })
        .then(() => {
          this.loading_serie = false;
          this.dialog_serie = false;
          this.nome_serie = "";
        });
    },
  },
};
</script>
